import { ICaseStudyDetails } from '@/interfaces';
import styles from './TreatmentAccodian.module.css';
import { useState } from 'react';
type props = {
    caseStudyData: ICaseStudyDetails
}
export function TreatmentAccodian({ caseStudyData }: props) {
    const [active, setActive] = useState(-1)
    const handleClick = (e: any, index: number) => {
        e.preventDefault();
        setActive(prevState => (prevState === index ? -1 : index));
    };
    return (
        <section className="mb30">
            <div className="container">
                <div className={styles.set}>
                    <div className={styles.items} onClick={(e) => handleClick(e, 0)}>
                        <div className={styles.formHeader}>
                            <div className={`${styles.formTitle} font25 fontsm16 text666 fontMedium`}>Self-Assessment Form</div>
                        </div>
                        <i className={`fa ${active === 0 ? styles.fa_minus : styles.fa_plus}`}></i>
                    </div>
                    <div className={`${styles.content} ${active === 0 ? styles.display : ""}`}>
                        <div className={`${styles.formSection} mb30`}>
                            <div className={`${styles.formContent} active`}>
                                <div className={styles.formSec}>
                                    <div className={styles.formCol}>
                                        <div className="selfAssessment-Title font25 fontsm16 text46675 mb20">Lifestyle Habits</div>
                                        <span className={styles.list} dangerouslySetInnerHTML={{ __html: caseStudyData?.self_assessment?.self_assessment_topic_1 }} />
                                    </div>
                                    <div className={styles.formCol}>
                                        <div className="selfAssessment-Title font25 fontsm16 text46675 mb20">Performance Health</div>
                                        <span className={styles.list} dangerouslySetInnerHTML={{ __html: caseStudyData?.self_assessment?.self_assessment_topic_2 }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.set}>
                    <div className={styles.items} onClick={(e) => handleClick(e, 1)}>
                        <div className={styles.formHeader}>
                            <div className={`${styles.formTitle} font25 fontsm16 text666 fontMedium`}>Doctor Consultation</div>
                        </div>
                        <i className={`fa ${active === 1 ? styles.fa_minus : styles.fa_plus}`}></i>
                    </div>
                    <div className={`${styles.content} ${active === 1 ? styles.display : ""}`}>
                        <div className={`${styles.formSection} mb30`}>
                            <div className={`${styles.formContent}`}>
                                <span className="fontRegular font16" dangerouslySetInnerHTML={{ __html: caseStudyData.consultant }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.set}>
                    <div className={styles.items} onClick={(e) => handleClick(e, 2)}>
                        <div className={styles.formHeader}>
                            <div className={`${styles.formTitle} font25 fontsm16 text666 fontMedium`}>Treatment Journey</div>
                        </div>
                        <i className={`fa ${active === 2 ? styles.fa_minus : styles.fa_plus}`}></i>
                    </div>
                    <div className={`${styles.content} ${active === 2 ? styles.display : ""}`}>
                        <div className={`${styles.formSection} mb30`}>
                            <div className={`${styles.formContent}`}>
                                <span className={styles.list} dangerouslySetInnerHTML={{ __html: caseStudyData?.treatment_journey }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}